import { jsx as n, jsxs as f } from "react/jsx-runtime";
import { ListBoxSelect as c, Tooltip as p } from "@systemeio/ui";
import { useEditorState as d } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as b } from "react";
import { twMerge as x } from "tailwind-merge";
import { ToolbarSelectButton as g } from "../../components/content-controls/toolbar-select-button.mjs";
import { TOOLTIP_STYLES as T, getToolbarIconClassName as h } from "../../constants/default-styles.mjs";
import { useTranslation as A } from "../../i18n.mjs";
import I from "../../icons/align-center-icon.mjs";
import C from "../../icons/align-justify-icon.mjs";
import E from "../../icons/align-left-icon.mjs";
import L from "../../icons/align-right-icon.mjs";
import { TextAlignEnum as s } from "./text-align-enum.mjs";
import { getCurrentTextAlignValue as N, getTextAlignValues as u } from "./utils/text-align.mjs";
import { isImageSelected as R } from "../image-extension/utils/is-image-selected.mjs";
const q = (i) => {
  const { t: a } = A(), t = d({
    editor: i,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      textAlign: N(o),
      isImageSelected: R(o)
    })
  }), r = (t == null ? void 0 : t.textAlign) ?? s.Left, l = !(t != null && t.isEditable) || !!(t != null && t.isImageSelected);
  return b(() => {
    const o = () => {
      const e = h(l);
      switch (r) {
        case s.Right:
          return /* @__PURE__ */ n(L, { className: e });
        case s.Center:
          return /* @__PURE__ */ n(I, { className: e });
        case s.Justify:
          return /* @__PURE__ */ n(C, { className: e });
        case s.Left:
        default:
          return /* @__PURE__ */ n(E, { className: e });
      }
    }, m = (e) => {
      if (!i || !e) return null;
      i.chain().focus().setTextAlign(e).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ n(
        c,
        {
          disabled: l,
          value: r,
          data: u(r),
          onChange: m,
          optionClassName: "group",
          children: (e) => /* @__PURE__ */ n(
            p,
            {
              disabled: l,
              label: a("text_align"),
              anchor: "left",
              ...T,
              children: /* @__PURE__ */ n(g, { disabled: l, open: e, children: o() })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ n(
        c,
        {
          optionsClassName: "z-40",
          disabled: l,
          value: r,
          data: u(r),
          onChange: m,
          optionClassName: "group",
          children: (e) => /* @__PURE__ */ f(
            g,
            {
              className: x("flex gap-1"),
              disabled: l,
              open: e,
              children: [
                o(),
                a("text_align")
              ]
            }
          )
        }
      )
    };
  }, [i, l, r, a]);
};
export {
  q as useTextAlignExtensionToolbar
};
